import { useQuery } from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/api-key'
import { useQueryParams } from 'ssr/router'

export const getUserByIdQuery = /* GraphQL */ `
  query GetUserById($id: ID!) {
    getUserById(id: $id) {
      id
      firstName
      lastName
      email
    }
  }
`

const getUserByIdKey = (id: string) => ['getUserById', id]

export const useGetUserById = () => {
  const { userId } = useQueryParams()
  return useQuery({
    queryKey: getUserByIdKey(userId),
    queryFn: async () => {
      const data = (await graphql({
        query: getUserByIdQuery,
        variables: { id: userId }
      })) as any

      return data?.getUserById
    }
  })
}
